import { useEffect } from "react"

export const useClickOutside = (callback: (event: MouseEvent) => void, ref: React.RefObject<HTMLElement | null>) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
        callback(event)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [callback, ref])

  return ref
}
